import "./qrcode.scss";
import Info from '../../../assets/images/icons/info.png';
import Pix from '../../../assets/images/icons/pix.png';
import Copy from '../../../assets/images/icons/copy.png';

import React, { useEffect, useState } from 'react'

import { StepProps } from '../../../types/helpers'
import { brlFormatter, brlFormatter4DigitsDecimals } from "../../../utils";
import { useAppDispatch, useAppSelector } from "../../../features";
import { getPaymentCharge, getPaymentChargeInfo, getPaymentCreationInfo, setInPayment, setPaymentChargeInfo, setPaymentCompleted, setPaymentCreationInfo } from "../../../store/TransactionSlice";
import { QRCodeSVG } from "qrcode.react";
import Skeleton from "../../utils/skeleton/skeleton";

const PAYMENT_TIMER = 120;

export const QrCodePayment: React.FC<StepProps> = (props) => {

    const dispatch = useAppDispatch();

    const [timer, setTimer]                         = useState(PAYMENT_TIMER);
    const [copyLoading, setCopyLoading]             = useState<boolean>(false);
    const [currenctCurency, setCurrenctCurency]     = useState<string>('brl');

    const paymentPaymentInfo    = useAppSelector(getPaymentCreationInfo);
    const paymentChargeInfo     = useAppSelector(getPaymentChargeInfo);

    const pixCode = paymentPaymentInfo?.qrcode;

    useState(()=> {
        setTimer(paymentPaymentInfo.expires_in)
    });

    useEffect(() => {
        dispatch(setInPayment(true));
        VerifyPaymentStatus(paymentPaymentInfo.charge_id);
        setCurrenctCurency(localStorage.getItem('currentPayment') || ``)
    }, []);

    useEffect(() => {

        const countdown = setInterval(() => {
            if (timer <= 0) {
                console.dir('cancel purchase');
                clearInterval(countdown);
                cancelPayment();
            } else {
                setTimer(timer - 1);
            }
        }, 1000);

        return () => {
            clearInterval(countdown);
        }


    }, [timer, setTimer, paymentChargeInfo])

    useEffect(() => {

        const verifyPurchase = setInterval(() => {
            VerifyPaymentStatus(paymentPaymentInfo.charge_id);
        }, 2000);

        return () => {
            clearInterval(verifyPurchase);
        }


    }, [paymentChargeInfo])

    const handlePixCopy = async () => {
        setCopyLoading(true);
        try {
            await navigator.clipboard.writeText(pixCode);
            console.log('Copied to clipboard:', pixCode);
            const timer = setTimeout( () => {
                setCopyLoading(false);
                clearTimeout(timer);
            },2000);
        } catch (error) {
            console.error('Unable to copy to clipboard:', error);
            const timer = setTimeout( () => {
                setCopyLoading(false);
                clearTimeout(timer);
            },2000);
        }
    };

    const cancelPayment = () => {
        dispatch(setPaymentCreationInfo({}))
        dispatch(setPaymentChargeInfo({}))
        dispatch(setInPayment(false))
        props.decreaseStep();
    }

    const VerifyPaymentStatus = (chargeId: string) => {
        dispatch(getPaymentCharge(chargeId));
        if (paymentChargeInfo?.charge?.status === 'done') {
            dispatch(setPaymentCreationInfo({}))
            dispatch(setPaymentChargeInfo({}))
            dispatch(setInPayment(false))
            dispatch(setPaymentCompleted(true))
        }
    }

    return (
        <div className='home-qr-code'>
            
            { currenctCurency === 'BRL' ? (
                <div className="alert alert-payment-currency-info">
                    A troca ocorrerá pelo valor de mercado, caso a opção de troca automática esteja ativada
                </div>
            ) : (
                <div className="alert alert-payment-currency-info">
                    Para assegurar o preço selecionado, será aplicada uma taxa correspondente durante todo o período de validade do QrCode.
                </div>
            )}

            <ul className="has-border">
                <li>
                    Valor Total
                    <span>
                        {paymentChargeInfo?.charge?.amount && paymentChargeInfo?.charge?.amount}
                        {!paymentChargeInfo?.charge?.amount && 
                            <>
                                <Skeleton variant="text"/>
                            </>
                        }
                    </span>
                </li>
                <li>
                    Valor Estimado<br /> de {paymentChargeInfo?.charge?.payee_currency}
                    <span>
                        {paymentChargeInfo?.charge?.price && brlFormatter4DigitsDecimals.format(paymentChargeInfo?.charge?.amount/paymentChargeInfo?.charge?.price)}
                        {!paymentChargeInfo?.charge?.price && 
                            <>
                                <Skeleton variant="text"/>
                            </>
                        }
                    </span>
                </li>
                <li>
                    Pagar em até {paymentPaymentInfo.expires_in} segundos
                    <span>
                        {timer}
                    </span>
                </li>
            </ul>
            <h1> Voce tem {paymentPaymentInfo.expires_in} segundos para pagar. </h1>
            <div className="qrcode-wrapper">
                <div className="qrcode-img">
                    <QRCodeSVG
                        value={pixCode}
                        bgColor="#383838"
                        fgColor="#ddd"
                        width="100%"
                        height="unset"
                    />
                </div>
            </div>
            <div className="pix" onClick={handlePixCopy}>
                <span>
                    <img src={Pix} alt="" />
                    Cópia e cola
                    <img src={Copy} alt="" className="copy" />
                </span>
                {
                    copyLoading ? 
                    <>
                        <p>
                            Código copiado com sucesso. Agora é só pagar
                        </p>
                    </>
                    :
                    <>
                        <p>
                            {pixCode}
                        </p>
                    </>
                }
            </div>

            <h2>
                - Instruções de segurança - 
                <span> Não caia em golpes verificando os seguintes passo:</span>
            </h2>
            <ul className='security-info'>
                <li><img src={Info} alt="" /> Se o banco e agência estão correto</li>
                <li><img src={Info} alt="" /> Se o valor está correto</li>
                <li><img src={Info} alt="" /> Se o recebedor é a TRK BIT</li>
            </ul>

            <button onClick={() => cancelPayment()} className="cancelButton">
                Refazer compra
            </button>

        </div>
    )
}